/**
 * A 24×24 color swatch used by the per-side piece color picker (Phase 3).
 * Mirrors `ThemeTile`'s a11y: `role="radio"` inside a `role="radiogroup"`,
 * `aria-checked`, and a clickable button so keyboard activation works.
 */
export interface SwatchProps {
  readonly id: string;
  readonly label: string;
  readonly color: string;
  readonly selected: boolean;
  readonly onClick: () => void;
}

export function Swatch({ id, label, color, selected, onClick }: SwatchProps) {
  return (
    <button
      type="button"
      // biome-ignore lint/a11y/useSemanticElements: visual design requires button styling + keyboard activation; radio role is correct inside a role="radiogroup" parent (ThemePicker)
      role="radio"
      aria-checked={selected}
      aria-label={label}
      data-testid={`swatch-${id}`}
      data-color={color}
      onClick={onClick}
      className={`relative h-7 w-7 rounded-full border-2 transition-all hover:scale-110 active:scale-95 ${
        selected ? 'border-berry ring-2 ring-berry/40' : 'border-ink/20'
      }`}
      style={{ backgroundColor: color }}
    />
  );
}
